export default __webpack_public_path__ + "static/media/chevron-up.45f0276f.svg";